export default "__VITE_ASSET__M9tyKB4q__"